import { useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { Outlet } from "react-router";

import { Toaster } from "@/components/ui/toaster";

import { useErrorToast } from "@/hooks";
import { env } from "@/lib/env";
import { errorStore } from "@/stores";

// TODO: Is this the best place to initialize Mixpanel?
if (env.getIsProduction()) {
  mixpanel.init(env.getMixpanelToken(), {
    track_pageview: true,
    persistence: "localStorage",
    record_mask_text_selector: "", // Prevents text masking for non-input elements during recording.
    record_sessions_percent: 100, // Activate session recording for 100% of users.
  });
}

export const RootLayout = () => {
  // TODO: Global error toast. Might want something better.
  const errorToast = useErrorToast();
  const errorMessage = errorStore((state) => state.errorMessage);
  const setErrorMessage = errorStore((state) => state.setErrorMessage);
  useEffect(() => {
    if (errorMessage) {
      // If there is an error message, show the message in the error toast and then clear
      // the error message from the store so we don't show the same message multiple times.
      errorToast({
        description: errorMessage,
      });
      setErrorMessage(null);
    }
  }, [errorMessage, errorToast, setErrorMessage]);

  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
};
